import './toast-item.styles.scss';

export default angular.module('directives.abToastItem', [])
  .directive('abToastItem', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        toast: '=',
        remove: '&',
      },
      templateUrl: require('./toast-item.template.html'),
    };
  })
  .name;
